import * as React from 'react';
import Grid from '@mui/material/Grid';
import { Button, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import Logo from '../../layouts/ui-component/Logo';
import SimCardIcon from '@mui/icons-material/SimCard';
import { makeStyles } from '@mui/styles';
import Color from '../../layouts/Color';

const useStyles = makeStyles(function (theme) {
  return {
    gridContainer: {
      [theme.breakpoints.up("sm")]: {
        paddingLeft: '100px',
        paddingRight: '100px'
      },
      [theme.breakpoints.up("md")]: {
        paddingLeft: '150px',
        paddingRight: '150px'
      },
      [theme.breakpoints.up("lg")]: {
        paddingLeft: '200px',
        paddingRight: '200px'
      },
      [theme.breakpoints.only("xl")]: {
        paddingLeft: ' 300px',
        paddingRight: '300px'
      },
    },
  };
});

const container = { mt: 2 };
const valueStyle = { textAlign: 'left' };
const btnStyle = { color: Color.Main, borderRadius: '10px', textTransform: 'none', textalign: 'right' };
const highLightText = { textTransform: 'capitalize', textAlign: 'right' };
const buttonGrid = { textAlign: 'right' };

export default function Confirm() {
  const classes = useStyles();
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <React.Fragment>
      <Typography variant="h3" marked="left" gutterBottom>Transaction confirmation</Typography>
      <Grid className={classes.gridContainer}>
        <Grid container spacing={3} sx={container}>
          <Grid item >
            <Typography variant="h3">
              From account
            </Typography>
          </Grid>
          <Grid container item justifyContent="space-between" alignItems="center" flexDirection="row">
            <Grid container item xs={6}  >
              <Grid item xs={12} sx={valueStyle}>
                <Logo />
              </Grid>
              <Grid item xs={12} sx={valueStyle}>
                <Typography variant="h4">
                  9704 03** **** 9030
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={6} sx={buttonGrid}>
              <Button variant="outlined" sx={btnStyle}
                size={matchDownMD ? 'small' : 'medium'}>
                Change
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Divider />
        <Grid container spacing={3} sx={container} >
          <Grid item >
            <Typography variant="h3">
              Transaction information
            </Typography>
          </Grid>
          <Grid container item spacing={2} justifyContent="space-between" alignItems="center" flexDirection="row">
            <Grid container item xs={6}  >
              <Grid item xs={12} sx={valueStyle}>
                <Typography >
                  Account
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="h4" sx={highLightText}>
                <SimCardIcon color="error" />
                Telecommunication
              </Typography>
            </Grid>
            <Grid container item xs={6}>
              <Grid item xs={12} sx={valueStyle}>
                <Typography >
                  Top up the phone number
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="h4" sx={highLightText}>
                0376624470
              </Typography>
            </Grid>
            <Grid container item xs={6}>
              <Grid item xs={12} sx={valueStyle}>
                <Typography >
                  Home network
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={6} >
              <Typography variant="h4" sx={highLightText}>
                Viettel
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Divider />
        <Grid container spacing={3} sx={container} >
          <Grid item >
            <Typography variant="h3">
              Transaction amount
            </Typography>
          </Grid>
          <Grid container item spacing={2} justifyContent="space-between" alignItems="center" flexDirection="row">
            <Grid container item xs={6}  >
              <Grid item xs={12} sx={valueStyle}>
                <Typography >
                  Amount 
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="h4" sx={highLightText}>
                20.000đ
              </Typography>
            </Grid>
            <Grid container item xs={6}>
              <Grid item xs={12} sx={valueStyle}>
                <Typography >
                  Discount
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="h4" sx={highLightText}>
                5%
              </Typography>
            </Grid>
            <Grid container item xs={6}>
              <Grid item xs={12} sx={valueStyle}>
                <Typography >
                  Transaction fee
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={6} >
              <Typography variant="h4" sx={highLightText}>
                Free
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}